import config from 'config';

import { DEFAULT_METADATA } from 'themes/[theme]/strings/external'; // eslint-disable-line import/order

export const DEFAULT_METADATA_EXTENDED = {
  ...DEFAULT_METADATA,
  meta: [...DEFAULT_METADATA.meta,
    {
      name: 'robots',
      content: 'NOODP,NOYDIR',
    },
    {
      name: 'fb:admins',
      content: config.facebookAdmins,
    },
  ],
};
